export default __webpack_public_path__ + "static/media/full-logo.001501af.png";